/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Platform of the terminal application.
 */
export const TerminalApplicationPlatform = {
  Undefined: "undefined",
  Ios: "ios",
  Android: "android",
} as const;
/**
 * Platform of the terminal application.
 */
export type TerminalApplicationPlatform = ClosedEnum<
  typeof TerminalApplicationPlatform
>;

/** @internal */
export const TerminalApplicationPlatform$inboundSchema: z.ZodNativeEnum<
  typeof TerminalApplicationPlatform
> = z.nativeEnum(TerminalApplicationPlatform);
/** @internal */
export const TerminalApplicationPlatform$outboundSchema: z.ZodNativeEnum<
  typeof TerminalApplicationPlatform
> = TerminalApplicationPlatform$inboundSchema;
